import { graphql } from '../graphql/generated';

export const FRONT_DESK_DOCTOR_QUERY = graphql(`
  query FrontDeskDoctor {
    assignmentForCurrentUser {
      id
      primaryDoctor {
        id
        assignedLabs {
          lab {
            id
            name
            identifier
          }
        }
      }
    }

    doctorsForCurrentUser {
      id
      meAddress
      assignedLabs {
        customerId
        lab {
          id
          identifier
        }
      }
    }

    importedDoctors {
      id
      labId
      salutation
      name
      specialist
      hvNumber
      customerId
      meAddress
      firstName
      lastName
      preTitle
      postTitle
      street
      zip
      city
      email
      phone
      comment
    }
  }
`);

export const CREATE_FRONT_DESK_DOCTOR_MUTATION = graphql(`
  mutation CreateFrontDeskDoctor($input: CreateDoctorFrontDeskInput!) {
    createDoctorFrontDesk(input: $input) {
      id
    }
  }
`);
